import 'primeflex/primeflex.css';

import { confirmDialog } from 'primereact/confirmdialog';
import { CSSProperties, ReactNode } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

type TProps = {
  contents?: string | undefined | ReactNode;
  acceptLabel?: string | undefined;
  rejectLabel?: string | undefined;
  rejectClassName?: string | undefined;
  onConfirm: any;
  onReject?: any | undefined;
  closable?: boolean | undefined;
  contentStyle?: CSSProperties | undefined;
  infoOnly?: boolean | undefined;
};

export const confirmGeneric = ({
  contents,
  acceptLabel,
  rejectLabel,
  rejectClassName,
  onConfirm,
  onReject,
  closable,
  contentStyle,
  infoOnly,
}: TProps) => {
  return confirmDialog({
    message: (
      <>
        <ConfirmGenericStyles />
        <ConfirmGenericMessage>{contents}</ConfirmGenericMessage>
      </>
    ),
    rejectLabel: rejectLabel || 'Cancel',
    acceptLabel: acceptLabel || 'Confirm',
    accept: onConfirm,
    reject: onReject,
    headerClassName: 'hidden',
    className: `confirm-generic-dialog custom-dialog`,
    closable: closable ?? false,
    contentStyle,
    acceptClassName: infoOnly ? 'p-button-hidden' : undefined,
    rejectClassName,
    resizable: false,
  });
};

const ConfirmGenericStyles = createGlobalStyle`
.confirm-generic-dialog {
  border-radius: 0;
  border-width: 0;

  .p-dialog-footer {
    border-radius: 0;
    padding-top: 30px;
    padding-bottom: 40px;
  }
}
`;

const ConfirmGenericMessage = styled.div`
  width: 525px;
  padding-top: 40px;
  padding-left: 60px;
  padding-right: 60px;
  text-align: center;
`;

export const ConfirmGenericTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 1.25;
  text-align: center;
  word-wrap: break-word;
  margin-top: 30px;
  margin-bottom: 14px;
`;
